<!-- 个人记工 点工 详情弹窗-->
<template>
  <div>
    <p class="see_detail" @click="visible = true;getDetail()">查看详情</p>

    <el-dialog
      title="个人记工-点工"
      :visible.sync="visible"
      width="800px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="title">
        <span>当前项目：</span>{{ detail.projectName }}
      </div>
      <div class="content">
        <el-row class="card_item">
          <el-col :span="12"><span class="color666">日期：</span>{{ workTime }}</el-col>
          <el-col :span="12"><span class="color666">上班时长：</span>{{ workDuration }}</el-col>
        </el-row>
        <el-row class="card_item">
          <el-col :span="12"><span class="color666">加班时长：</span> {{ detail.workOvertimeDuration ? detail.workOvertimeDuration+'小时' : "无加班" }}</el-col>
          <el-col :span="12"><span class="color666">工资标准：</span> 上班{{ detail.workStandardSalary || '--' }}元 /
            工，加班{{ detail.workOvertimeSalary || '--' }}元 / 小时
          </el-col>
        </el-row>
        <el-row class="card_item">
          <el-col :span="12">
            <span class="color666">当日工钱（自动计算）：</span><span class="salary">{{ detail.workStandard ? Number(detail.salary).toFixed(2) : '--' }}元</span>
          </el-col>
          <el-col :span="12" v-if="$route.query.type==='2'"><span class="color666">工人：</span>{{ detail.workerName }}</el-col>
        </el-row>
        <div style="display: flex" class="card_item" v-if="detail.remark">
          <div class="color666" style="width:3em">备注：</div>
          <div style="flex: 1">{{ detail.remark }}</div>
        </div>
        <div style="display: flex" v-if="detail.picture">
          <div style="width:3em"></div>
          <div style="flex: 1">
            <el-image v-for="(item,index) in detail.picture.split(',')" :key="index" :src="item"
                      :preview-src-list="[item]"
                      class="pics"></el-image>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {api} from '@/api/apiRecord.js'

export default {
  name: "waterDetail",
  props: {
    project: {
      type: [Object, undefined],
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false,
      detail: {}
    }
  },
  methods: {
    async getDetail() {
      const params = {
        no:this.project.workRecordNo,
        type:this.$route.query.type
      }
      const res = await api.workRecordDetail(params)
      if (res.data.code === 200) {
        this.detail = res.data.data
      }
    }
  },
  computed: {
    workTime() {
      const time = new Date(this.detail.workTime)
      return `${time.getFullYear()}年${time.getMonth() + 1}月${time.getDate()}日`
    },
    workDuration(){ // 上班时长
    switch (this.detail.workType) {
      case "1":
        return this.detail.workDuration + '个工'
        break;
      case "2":
        return this.detail.workDuration + '个工'
        break;
      case "3":
        return '休息'
        break;
      case "4":
        return this.detail.workDuration + '小时'
        break;
      default:
        break;
    }

    }
  }
}
</script>

<style lang="scss" scoped>
.see_detail {
  color: #0286DF;
  cursor: pointer;
}

/deep/ .el-dialog__body {
  padding: 0;
}

.title {
  padding: 0 20px;
  background: #F5F7FA;
  line-height: 40px;
  font-size: 16px;

  span {
    color: #666;
    font-weight: normal;
  }
}

.content {
  padding: 20px;
}

.color666 {
  color: #666666;
}

.salary {
  color: #FF6600;
  margin-right: 20px;
}

.pics {
  width: 100px;
  height: 100px;
  margin-right: 20px;
}

.card_item {
  margin-bottom: 15px;
  color: #333333
}

.card_item:last-of-type{
  margin-bottom: 0
}

/deep/ .el-dialog__footer {
  padding: 0;
}
</style>
